import { Spin } from "antd";

export default function LoadingContent(props) {
  return (
    <div
    className={ "spin-container " + (props.className ? props.className : "") }
      style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center" , margin: "5% 0px"}}
    >
      <Spin size="large" />
    </div>
  );
}
